export default __webpack_public_path__ + "static/media/Rosaura Rosy.6c56b661.jpg";